<div class="google-redirect-wrapper">
    <div class="google-redirect-card">
        <div class="spinner"></div>
        <h2>Procesando autenticación</h2>
        <p>
            Estamos validando tu cuenta de Google.<br />Esto puede tardar unos
            segundos.
        </p>
    </div>
</div>
